import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draft from "./components/draft.vue";
import viewArticles from "../email/components/viewArticles.vue";
import contentView from "../email/components/contentView.vue";
import { gmToolNew, gmTool, serchSelect } from "@/mixins/index";
import { vipEmailsTemplateList, vipEmailsTemplateDel } from "@/api/gmtool/packageCode";
export default {
  name: "gmToolNewemail",
  components: {
    draft: draft,
    viewArticles: viewArticles,
    contentView: contentView
  },
  mixins: [gmToolNew, gmTool, serchSelect],
  data: function data() {
    return {
      advanced: false,
      paramsData: {
        page: 1,
        page_size: 10,
        language: '',
        template_name: ''
      },
      tableData: [],
      // 表格数据
      total: 0,
      value1: '',
      number: "",
      LanguageList: [{
        label: this.$t('langEnglish'),
        value: '0',
        text: 'en',
        disabled: false
      }, {
        label: this.$t('langTraditionalChinese'),
        value: '1',
        text: 'tc',
        disabled: false
      }, {
        label: this.$t('langSimplifiedChinese'),
        value: '2',
        text: 'zh',
        disabled: false
      }, {
        label: this.$t('langVietnamese'),
        value: '3',
        text: 'vn',
        disabled: false
      }]
    };
  },
  created: function created() {},
  methods: {
    getList: function getList(page) {
      var _this = this;

      this.paramsData.page = page ? page : this.paramsData.page;
      this.reqLoading = true;
      vipEmailsTemplateList(_objectSpread({}, this.paramsData)).then(function (res) {
        if (res.code == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    searchClick: function searchClick() {
      this.paramsData.page = 1;
      this.getList();
    },
    currentChaneg: function currentChaneg(e) {
      this.paramsData.page = e;
      this.getList();
    },
    // 删除配置
    deleHandle: function deleHandle(id) {
      var _this2 = this;

      this.$confirm(this.$t('confirmDeleteEmail'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vipEmailsTemplateDel({
                  id: id
                }).then(function (res) {
                  _this2.getList();

                  _this2.$message({
                    type: "success",
                    message: _this2.$t('operationSuccess')
                  });
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};